import { Shield, Eye, Lock, AlertCircle, CheckCircle } from "lucide-react";
import { PortalLayout } from "../components/PortalLayout";

const securityFeatures = [
  {
    icon: Shield,
    title: "ISO 27001-Aligned Framework (In Progress)",
    description: "LEO Group is actively implementing ISO 27001-aligned controls and governance processes as part of its ongoing certification journey.",
  },
  {
    icon: Eye,
    title: "Access Monitoring & Logging",
    description: "All system and portal access is continuously monitored, time-restricted, and subject to full audit trail documentation.",
  },
  {
    icon: Lock,
    title: "Data Protection Protocols",
    description: "Structured data handling, encryption standards, and confidentiality agreements govern all information flows.",
  },
  {
    icon: AlertCircle,
    title: "Incident Response Framework",
    description: "Defined escalation paths and response procedures ensure rapid containment and stakeholder notification.",
  },
  {
    icon: CheckCircle,
    title: "Compliance with Data Protection Regulations",
    description: "LEO Group adheres to data protection regulations such as GDPR, CCPA, and other relevant laws to ensure data privacy and security.",
  },
];

export function SecurityCompliancePage() {
  return (
    <PortalLayout>

      {/* Header */}
      <div className="mb-14">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#7B1A1A] mb-4">
          Security & Compliance
        </p>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-[#1F2933] mb-8 leading-tight max-w-3xl">
          Information Security as a Foundational Principle
        </h1>
        <div className="space-y-4 text-[#4B5563] max-w-4xl leading-relaxed">
          <p>
            Information security is a foundational principle across all LEO Group operations. The organisation
            implements structured security practices aligned with internationally recognised standards and is
            currently in the process of formalising an ISO 27001-aligned information security management framework.
          </p>
          <p>
            While certification is in progress, security principles are already embedded across infrastructure
            environments, software development practices, data handling and processing, and access control and
            monitoring systems.
          </p>
          <p>
            All systems are continuously monitored, and access is logged and subject to audit. Security incidents
            are managed through defined response protocols with clear escalation paths and stakeholder notification
            procedures.
          </p>
        </div>
      </div>

      {/* Security Features */}
      <div className="mb-14">
        <h2 className="text-xl font-semibold text-[#1F2933] mb-8">Structured Security Practices</h2>
        <div className="space-y-4">
          {securityFeatures.map(({ icon: Icon, title, description }) => (
            <div key={title} className="bg-white border border-[#E5E7EB] rounded-lg p-6 shadow-sm">
              <div className="w-full h-px bg-[#7B1A1A] mb-4" />
              <div className="flex items-center gap-3 mb-3">
                <Icon className="w-5 h-5 text-[#7B1A1A]" />
                <h3 className="text-sm font-semibold text-[#1F2933]">{title}</h3>
              </div>
              <p className="text-sm text-[#4B5563] leading-relaxed pl-8">{description}</p>
            </div>
          ))}
        </div>
      </div>


    </PortalLayout>
  );
}
